import React, { useState } from 'react'
import classNames from 'classnames'
import { AsP, Text } from '@/atoms/Text'
import { useLocale } from '@/utils/LocaleUtil'
import {
  getGradient,
  getBoxShadow,
  getDateStyle,
  getHolidayNameStyle,
} from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayCardStyles'
import type { Holiday } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'

interface HolidayDateCardProps {
  disabled: boolean
  date: Date
  onClick: () => void
  selected: boolean
  holiday: Holiday
}

export const HolidayDateCard: React.FC<HolidayDateCardProps> = ({ disabled, date, onClick, selected, holiday }) => {
  const { locale } = useLocale()
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={classNames(
        'w-[72px] h-24 relative rounded-xl hover:scale-105 hover:bg-white text-core-gray-900 hover:!z-30',
        {
          'cursor-not-allowed': disabled,
          'cursor-pointer': !disabled,
          '!bg-core-gray-950 shadow-[0_8px_16px_-1px_rgba(0,0,0,0.08)]': selected,
        },
      )}
      style={{
        backgroundColor: 'white',
        backgroundImage: getGradient(holiday, selected, isHovered),
        boxShadow: getBoxShadow(holiday, selected),
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div className="h-full flex-col justify-center overflow-hidden pt-0.5 text-center">
        <div className="relative h-full overflow-hidden">
          <div className="absolute inset-0 h-full w-full ">
            <div className="flex h-[115%] w-full items-center justify-center">
              <span
                className="!bg-clip-text text-center !font-nomadic !text-[5em] !font-normal !leading-[100px]"
                style={getDateStyle(holiday, selected)}
              >
                {date.getDate()}
              </span>
            </div>
            <div className="absolute top-0 h-full w-full items-center justify-center">
              <div className="flex h-full flex-col justify-center pt-0.5 text-center">
                <Text
                  as={AsP}
                  weight="bold"
                  className={classNames('!text-xl !leading-[1.125] !font-nomadic', {
                    '!bg-clip-text': !selected,
                  })}
                  style={getHolidayNameStyle(holiday, selected)}
                >
                  {holiday.name}
                </Text>
                <Text
                  color="core-gray-700"
                  className={classNames('uppercase !font-[350] text-[0.6em] leading-3', {
                    '!text-core-gray-400': selected,
                    '!text-core-gray-700': !selected,
                  })}
                >
                  {date.toLocaleString(locale, { weekday: 'long' })}
                </Text>
              </div>
            </div>
          </div>
        </div>
        {selected && (
          <div
            className={classNames('absolute bottom-1 right-1/2 h-1 w-3 translate-x-2/4 rounded-full bg-oxide-bright')}
          ></div>
        )}
      </div>
    </div>
  )
}
